import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faDownload } from '@fortawesome/free-solid-svg-icons';

const TestList = ({ tests, handleTestClick }) => {
    const account = JSON.parse(localStorage.getItem("account"));
    const isAdmin = account?.is_admin === 1;
    

    const styles ={
        left:{
            textAlign:'left',
            width: isAdmin ? '70%' : '100%',
        },
        right:{
            background:'white',
            border:'1px solid #dddddd',
            width:'30%',
            padding:'24px',
            borderRadius:'16px',
            textAlign:'left'
        },
        waittest:{
            color:'#44526E',
            fontWeight:'bold'
        },
        btnTest:{
            width: '100%',
            backgroundColor: '#44526E',
            color: 'white',
            border: 'none',
            borderRadius: '64px',
            display: 'flex',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize:'24px',
            marginTop:'20px'
        },
        amountTest:{
            display:'flex',
            gap:'10px'
        },
        contenttest:{
            border:'1px solid #dddddd',
            borderRadius:'16px',
            padding:'24px',
            height:'241px',
            maxHeight: '241px', overflowY: 'auto',
        },
    }

    return (
        <div id="test-list">
            {tests?.length > 0 ? (
                tests
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .map((test) => {
                        // นับประเภทคำถามในแต่ละ test
                        let type1Count = 0;
                        let type2Count = 0;

                        test.questions.forEach((question) => {
                            if (question.type === '1') {
                                type1Count++;
                            } else if (question.type === '2') {
                                type2Count++;
                            }
                        });

                        return (
                            <div
                                key={test.id}
                                style={{
                                    padding: '24px',
                                    textAlign: 'left',
                                    gap: '8px',
                                    border: '1px solid #dddddd',
                                    borderRadius: '16px',
                                    display: 'flex',
                                    background: '#f2f2f2',
                                    marginBottom: '24px',
                                }}
                            >
                                <div style={{ ...styles.left }}>
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                        <div className="custom-checkbox">
                                            <input
                                                type="checkbox"
                                                id={`checkbox_${test.uid}`}
                                                checked={test.is_tested}
                                                disabled
                                            />
                                            <label htmlFor={`checkbox_${test.uid}`} style={styles.checkboxLabel}></label>
                                        </div>
                                        <a
                                            style={{
                                                color: '#000',
                                                fontSize: '24px',
                                                textDecoration: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {test.chapter}
                                        </a>
                                    </div>
                                    <div style={styles.contenttest}>
                                        <div style={styles.amountTest}>
                                            <p>• ปรนัย</p>
                                            <p style={{ color: '#44526e' }}>{type1Count}</p>
                                            <p>ข้อ </p>
                                        </div>
                                        <div style={styles.amountTest}>
                                            <p>• อัตนัย</p>
                                            <p style={{ color: '#44526e' }}>{type2Count}</p>
                                            <p>ข้อ</p>
                                        </div>
                                    </div>
                                    <button onClick={() => handleTestClick(test.uid, test.course_uid)} style={styles.btnTest}>
                                        <p>ทำแบบทดสอบ</p>
                                    </button>
                                </div>
                                {isAdmin ? (
                                <div style={styles.right}>
                                        <p>คะแนนที่ได้</p>
                                        {test.results && test.results.length > 0 ? (
                                        <>
                                            {test.results.map((result, index) => (
                                            <div key={index}>
                                                <div style={styles.amountTest}>
                                                {/* ปรนัย */}
                                                {result.type === '1' && (
                                                    <>
                                                    <p>• ปรนัย</p>
                                                    {test.is_tested === 0 ? (
                                                        <p style={styles.waittest}>ยังไม่ทำแบบทดสอบ</p>
                                                    ) : result.total_score === 0 ? (
                                                        <p style={styles.waittest}>กำลังดำเนินการ</p>
                                                    ) : (
                                                        <>
                                                        <p style={{ color: '#44526e' }}>{result.total_score}</p>
                                                        <p>คะแนน</p>
                                                        </>
                                                    )}
                                                    </>
                                                )}

                                                {/* อัตนัย */}
                                                {result.type === '2' && (
                                                    <>
                                                    <p>• อัตนัย</p>
                                                    {test.is_tested === 0 ? (
                                                        <p style={styles.waittest}>ยังไม่ทำแบบทดสอบ</p>
                                                    ) : result.total_score === 0 ? (
                                                        <p style={styles.waittest}>กำลังดำเนินการ</p>
                                                    ) : (
                                                        <>
                                                        <p style={{ color: '#44526e' }}>{result.total_score}</p>
                                                        <p>คะแนน</p>
                                                        </>
                                                    )}
                                                    </>
                                                )}
                                                </div>
                                            </div>
                                            ))}

                                            {/* ตรวจสอบสถานะ "กำลังดำเนินการ" */}
                                            {test.results.some((result) => result.total_score === 0) ? (
                                            <>
                                                <hr />
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <p style={{ color: 'black', textAlign: 'right', margin: 0 }}>
                                                    คะแนนรวม
                                                </p>
                                                <p
                                                    style={{
                                                    color: 'black',
                                                    textAlign: 'right',
                                                    margin: 0,
                                                    color: '#218730',
                                                    fontWeight: 'bold',
                                                    }}
                                                >
                                                    กำลังดำเนินการ
                                                </p>
                                                </div>
                                            </>
                                            ) : (
                                            <div>
                                                <hr />
                                                <p
                                                style={{
                                                    color: '#218730',
                                                    textAlign: 'right',
                                                    margin: 0,
                                                    fontWeight: 'bold',
                                                }}
                                                >
                                                {test.total_score}
                                                </p>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <p style={{ color: 'black', textAlign: 'right', margin: 0 }}>
                                                    คะแนนรวม
                                                </p>
                                                <p style={{ color: 'black', textAlign: 'right', margin: 0 }}>
                                                    / {test.max_score}
                                                </p>
                                                </div>
                                            </div>
                                            )}
                                        </>
                                        ) : (
                                        <p>ยังไม่มีผลการทดสอบ</p>
                                        )}
                                    </div>
                                    ) : (
                                        null
                                    )}
                            </div>
                        );
                    })
            ) : (
                <p>ไม่มีข้อมูล</p> // ถ้าไม่มีข้อมูล
            )}
        </div>
    );
};



export default TestList;
